export const throttle = (func: Function, ms: number) => {
  let isThrottled = false,
    savedArgs: IArguments,
    savedThis: any;

  return function () {
    if (isThrottled) {
      savedArgs = arguments;
      savedThis = this;
      return;
    }

    func.apply(savedThis, savedArgs);
    isThrottled = true;

    setTimeout(function () {
      isThrottled = false;
      if (savedArgs) {
        savedArgs = savedThis = null;
      }
    }, ms);
  };
};